<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.0/css/bootstrap.min.css">
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script> 
<script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.0/js/bootstrap.min.js"></script>
<div class="main-div">
</div>
<div class="overlay" *ngIf="loading()">
	<div class="center">
	    <mat-spinner class="custom-spinner"></mat-spinner>	
	</div>
</div>
<div style="display:flex;justify-content:center;align-items:center">
	<mat-card style="text-align: -webkit-center;margin: 10em auto;"> 
        <mat-card-header style="background-color: rgba(255, 255, 255, 1);">
            <mat-card-title>User Verification</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            Please enter the verification code sent to your email address or phone.
        </mat-card-content>
        <mat-card-content style="background-color: rgba(10, 245, 245, 1);">
        <form [formGroup]="verifyForm" (ngSubmit)="onSubmit()">
            <div class="verifyCode"
                 formArrayName="verifyCode">
                <div class="verifyCode">
                    <mat-form-field class="codeField" 
                                    appearance="outline" 
                                    *ngFor="let control of verifyCodeControls; let i = index">
                        <input #otpInput
                               matInput 
                               maxlength="1" 
                               class="code"
                               type="text" 
                               [formControlName]="i" 
                               (input)="handleInput($event, i)"
                               (paste)="handlePaste($event)"
                               required>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <button mat-raised-button
                color="primary"
                (click)="resetCode()">
            Reset Code
        </button>
        <div *ngIf="error() !== ''" class="error-message">
            {{ error() }}
        </div>
        </mat-card-content>       
	 </mat-card>
</div>	       
